import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import axiosInstance from "../services/axios";
import { Paths } from "../routes/paths";
import styles from "./css/LoginPage.module.css"; // אותה שפה עיצובית
import { ROLE_TYPES } from "../constants/api";
import { setSession } from "../auth/auth.utils";

export const CompleteProfilePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const [id, setId] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [error, setError] = useState("");

  if (!email) {
    return <p>לא התקבל אימייל. בצעי התחברות מחדש.</p>;
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axiosInstance.post("/login/complete-profile", {
        email,
        id,
        fname,
        lname
      });

      if (!response.data?.token) {
        setError("הפרופיל עודכן אך טוקן לא התקבל.");
        return;
      }

      // שמירת טוקן
      setSession(response.data.token);

      // ניווט לפי ROLE
      switch (response.data.role) {
        case ROLE_TYPES.ADMIN:
          navigate(`/${Paths.adminArea}`);
          break;
        case ROLE_TYPES.ANALYST:
          navigate(`/${Paths.analystArea}`);
          break;
        case ROLE_TYPES.CHILD:
          navigate(`/${Paths.parentArea}`);
          break;
        default:
          navigate(`/${Paths.home}`);
          break;
      }
    } catch (err: any) {
      setError(err?.response?.data || err.message);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.loginBox}>
        <h2>השלמת פרטי משתמש</h2>

        <form onSubmit={handleSubmit} className={styles.loginForm}>
          <input
            value={email}
            disabled
            className={styles.input}
          />

          <input
            placeholder="תעודת זהות"
            value={id}
            onChange={(e) => setId(e.target.value)}
            required
            className={styles.input}
          />

          <input
            placeholder="שם פרטי"
            value={fname}
            onChange={(e) => setFname(e.target.value)}
            required
            className={styles.input}
          />

          <input
            placeholder="שם משפחה"
            value={lname}
            onChange={(e) => setLname(e.target.value)}
            required
            className={styles.input}
          />

          <button className={styles.button} type="submit">
            שמירה והמשך
          </button>

          {error && <p className={styles.error}>{error}</p>}
        </form>
      </div>
    </div>
  );
};
